import axios from "@/api/axiosInstance";
import {
  DataEnvelope,
  Enrollment,
} from "@/modules/learningCenter/features/CourseDirectory/types/viewer";

// Self-enroll the current learner in a published course. Double-enroll is
// guarded server-side.
export const enrollCourse = async (courseUuid: string): Promise<Enrollment> => {
  const response = await axios.post<DataEnvelope<Enrollment>>(
    `/api/private/learning-center/courses/${courseUuid}/enroll`,
  );
  return response.data.data;
};
